import {
  postRequest,
  patchRequest,
  postFormDataRequest,
  getRequest,
  deleteRequest
} from "../lib/utils/request";

export const getAllAPI = async (
  apiHost,
  { limit, offset, sortField, sortDir, showUnvisible },
  requestOptions
) => {
  return await getRequest(
    `${apiHost}/v1/articles?limit=${limit}&offset=${offset}&sortField=${sortField}&sortDir=${sortDir}&showUnvisible=${showUnvisible}`,
    requestOptions
  );
};

export const getAPI = async (apiHost, { uid }, requestOptions) => {
  return await getRequest(`${apiHost}/v1/articles/${uid}`, requestOptions);
};

export const createAPI = async (apiHost, data, requestOptions) => {
  return await postRequest(`${apiHost}/v1/articles`, data, requestOptions);
};

export const updateAPI = async (apiHost, data, requestOptions) => {
  return await patchRequest(
    `${apiHost}/v1/articles/${data.uid}`,
    data,
    requestOptions
  );
};

export const deleteAPI = async (apiHost, { uid }, requestOptions) => {
  return await deleteRequest(`${apiHost}/v1/articles/${uid}`, requestOptions);
};

export const createImageAPI = async (apiHost, formData) => {
  return await postFormDataRequest(`${apiHost}/v1/files?type=image`, formData);
};



// WEBPACK FOOTER //
// ./src/common/article/api.js